<template>
  <div class="main print-no-padding">
    <h2 class="is-print-hide title-area">
      <span class="main-title">处方列表</span>
    </h2>
    <div class="list-content">
      <div class="listSearchArea is-print-hide">
        <supervise-search
          v-if="superviseRole"
          @search="search"
          :searchData="searchData"
          class="pull-left is-print-hide"
          ref="searchBar"
        >
          <template #drugName>
            <label-input
              label="药品名称"
              v-model="searchData.drugName"
              :query-search="queryDrugName"
              placeholder="请输入药品名称"
              :input-attr="{ maxlength: 30 }"
              type="autocomplete"
            />
          </template>
        </supervise-search>
        <search-input
          v-else
          @search="search"
          :searchData="searchData"
          class="pull-left is-print-hide"
          absurd
          :hide-export-button="false"
          :showReAuditPharmacistSource="showReAuditPharmacistSource"
          ref="searchBar"
        >
          <template #drugName>
            <label-input
              label="药品名称"
              v-model="searchData.drugName"
              :query-search="queryDrugName"
              placeholder="请输入药品名称"
              :input-attr="{ maxlength: 30 }"
              type="autocomplete"
            />
          </template>
          <template #prescriptionId>
            <label-input v-model="searchData.id" label="处方编号" placeholder="请输入处方编号" />
          </template>
          <template #userPhone>
            <label-input
              labelWidth="100px"
              v-model="searchData.phoneNumber"
              label="患者手机号"
              placeholder="请输入患者手机号"
            />
          </template>
          <template #patientName v-permission="'a,b,c,d,e,f'">
            <label-input label="患者姓名" placeholder="请输入患者姓名" v-model="searchData.patientName" />
          </template>
          <template #printStatus>
            <label-input label="打印状态">
              <el-select v-model="searchData.printStatus" placeholder="请选择打印状态" clearable>
                <el-option v-for="(value, key) in printStatus" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </label-input>
          </template>
          <template #applySourceList>
            <label-input label="处方来源" width="259px">
              <el-select
                v-model="searchData.applySourceList"
                placeholder="请选择处方来源"
                multiple
                filterable
                allow-create
                default-first-option
              >
                <el-option
                  v-for="item in APPLY_SOURCE"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </label-input>
          </template>
        </search-input>
      </div>
      <div class="totalData is-print-hide" v-if="superviseRole">共{{ prescriptionRes.totalCount }}条数据</div>
      <div class="toolbar is-print-hide" v-permission.not="'h,i,j'">
        <transition name="toolbar-in" mode="out-in">
          <el-button-group v-if="toolBarStatus === 'init'">
            <el-button class="delete" v-if="batchItemShow('删除')" icon="el-icon-delete" @click="batchDelete">
              批量删除
            </el-button>
            <el-button v-if="batchItemShow('下载')" icon="el-icon-download" @click="batchDownload">
              批量下载处方图片
            </el-button>
            <el-button
              v-if="batchItemShow('下载')"
              v-permission.not="'h,i,j'"
              @click="toolBarStatus = 'print'"
              icon="el-icon-printer"
            >
              {{ prescriptionTemplate === 1 ? '批量拼接打印处方' : '拼接打印处方' }}
            </el-button>
            <el-button v-if="batchItemShow('下载')" icon="el-icon-download" @click="downloadAll">
              {{ `下载查询结果处方图片${imageCount > 0 ? `(${imageCount})` : ''}` }}
            </el-button>
            <el-button v-if="batchItemShow('下载')" icon="el-icon-download" @click="exportAll">
              {{ `导出处方${prescriptionRes.totalCount ? `(${prescriptionRes.totalCount})` : ''}` }}
            </el-button>
            <el-button v-if="batchItemShow('下载')" icon="el-icon-download" @click="exportPrescriptionDetail">
              导出药品
            </el-button>
            <div style="display: inline-block">
              <el-dropdown placement="top">
                <el-button icon="el-icon-s-fold">更多</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleDownloadBatchEMR">批量下载处方和电子病历</el-dropdown-item>
                  <el-dropdown-item @click.native="handleDownloadQueryedEMR">
                    {{ `下载查询结果处方和电子病历${imageCount > 0 ? `(${imageCount})` : ''}` }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-button-group>
          <div class="operate-bar" v-else-if="toolBarStatus === 'delete'">
            <el-button @click="batchDeleteConfirm" class="delete">
              {{ `删除选中的处方${this.selectCount ? `(${this.selectCount})` : ''}` }}
            </el-button>
            <el-button @click="initToolBarStatus">取消</el-button>
          </div>
          <div class="operate-bar" v-else-if="toolBarStatus === 'print'">
            <el-button @click="batchPrint">打印选中的处方</el-button>
            <el-button @click="initToolBarStatus">取消</el-button>
          </div>
          <div class="operate-bar" v-else-if="toolBarStatus === 'downloadEMR'">
            <el-button @click="batchDownloadEMRConfirm">
              {{ `下载选中的处方和电子病历${this.selectCount ? `(${this.selectCount})` : ''}` }}
            </el-button>
            <el-button @click="initToolBarStatus">取消</el-button>
          </div>
          <div class="operate-bar" v-else>
            <el-button @click="batchDownloadConfirm">
              {{ `下载选中的处方图片${this.selectCount ? `(${this.selectCount})` : ''}` }}
            </el-button>
            <el-button @click="initToolBarStatus">取消</el-button>
          </div>
        </transition>
      </div>
      <prescription-table
        :prescriptionList="prescriptionRes.data"
        :batchType="selectBatchType"
        :toolBarStatus="toolBarStatus"
        :batchIds.sync="_prescription.batchIds"
        :permission="permission"
        :fresh="fresh"
        @search="search"
        @deleteId="delPrescription"
        :printImg.sync="printImg"
        :showReAuditPharmacistSource="showReAuditPharmacistSource"
      ></prescription-table>
      <div class="footer is-print-hide">
        <skinny-pagination
          :page-no="currentPage"
          @on-change="handleCurrentChange"
          :is-end="currentPage * pageSize >= prescriptionRes.totalCount"
        />
      </div>
    </div>
    <print-mode-modal
      :visible="printsModeVisible"
      @confirm="batchPrintConfirm"
      @close="printsModeVisible = false"
    ></print-mode-modal>
    <!-- <direction></direction> -->
  </div>
</template>

<script>
import superviseSearch from '@/components/superviseSearch';
import searchInput from '@/components/searchInput.vue';
import prescriptionTable from './components/prescriptionTable.vue';
import { hasPermission, downloadByLink, delObjectEmpty } from '@/util';
import Constant from '@/lib/constant';
import DownloadModal from './components/ImageDownloadModal';
import labelInput from '@/components/global/form/labelInput';
import dayjs from 'dayjs';
import SkinnyPagination from '@/components/skinnyPagination';
import print from '@/components/printImg/index';
import { MessageBox } from 'element-ui';
import printModeModal from './components/printModeModal.vue';
import { mapState } from 'vuex';
import Fetch from '@/api';

const { prescriptionHandlerRule, baseRole } = Constant;
let isloadFinish = true; // 限制重复请求

const formatEndTime = date => {
  return date.replace(/00:00:00/, '23:59:59');
};
export default {
  name: 'PrescriptionList',
  inject: ['_prescription'],
  components: {
    superviseSearch,
    searchInput,
    prescriptionTable,
    labelInput,
    SkinnyPagination,
    printModeModal
  },
  data() {
    return {
      batchTypes: [
        { title: '下载', rule: [2] },
        { title: '删除', rule: [2, 3, 4] }
      ],
      selectBatchType: null,
      batchIds: [], // 勾选的处方id
      currentPage: 1,
      prescriptionRes: {
        totalCount: 0
      },
      searchData: {
        id: '',
        drugstore: '',
        costType: '',
        patientName: '',
        date: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        prescriptionTotalStatus: '',
        advisoryType: '',
        prescriptionType: '',
        drugName: '',
        phoneNumber: '',
        printStatus: '',
        applySourceList: [],
        userIdList: [],
        canPrescriptionRevocation: false,
        prescriptionRevocationStatus: 0
      },
      imageCount: 0,
      toolBarStatus: 'init', // init download delete print
      printImg: [], // item[]
      pageSize: 12,
      pageSizes: [12, 24, 36, 48],
      printStatus: Constant.printStatus,
      APPLY_SOURCE: [
        { value: 'PC', label: 'PC' },
        { value: 'APP', label: 'APP' },
        { value: 'PAD', label: 'PAD' },
        { value: 'WX_MINI_PROGRAM', label: '小程序' },
        { value: 'OTHER', label: '其他' }
      ],
      permission: {},
      printsModeVisible: false,
      showReAuditPharmacistSource: false
    };
  },
  computed: {
    ...mapState('global', ['prescriptionTemplate']),
    ifFresh() {
      return this.$store.getters.ifFresh;
    },
    superviseRole() {
      return this.$store.getters.superviseRole;
    },
    selectCount() {
      return this._prescription.batchIds.length;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 刷新页面或者从详情页面进来默认不刷新数据
      ![null, 'PrescriptionDetail'].includes(from.name) && vm.reset();
    });
  },
  deactivated() {
    this._prescription.$off('searchDownload');
  },
  created() {
    this.search({
      startTime: dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
      endTime: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss')
    });
    // 获取划价权限接口
    this.getPricePermission();
    // 获取复审药师端白名单权限
    this.checkReAuditPharmacistSource();
  },
  activated() {
    if (this.ifFresh) {
      this.search();
      this.getPricePermission();
      this.$store.commit('prescription/CHANGEifFreshPrescriptionListState', false);
    }
  },
  methods: {
    getPricePermission() {
      Fetch.check_white_list_by_scene({
        scene: 'PRESCRIPTION_PRICING'
      }).then(res => {
        this.permission = res;
      });
    },
    checkReAuditPharmacistSource() {
      // 获取当前门店ID
      const storeList = this.$store.getters.storeList;
      if (!storeList || storeList.length === 0) {
        return;
      }
      const storeId = storeList[0].id;

      Fetch.whiteListBizCheck({
        bizKeyList: ['drugstore:prescriptionShowPharmacistAuditSource:sc'],
        storeId
      })
        .then(res => {
          // 检查返回结果
          const result = res.find(
            item => item.bizKey === 'drugstore:prescriptionShowPharmacistAuditSource:sc' && item.checkResult === true
          );
          this.showReAuditPharmacistSource = !!result;
        })
        .catch(() => {
          this.showReAuditPharmacistSource = false;
        });
    },
    reset() {
      // 刷新列表
      this.currentPage = 1;
      this.prescriptionRes = {};
      this.searchData = {
        id: '',
        drugstore: '',
        costType: '',
        patientName: '',
        date: '',
        prescriptionTotalStatus: '',
        advisoryType: '',
        drugName: '',
        phoneNumber: '',
        printStatus: ''
      };
      let params = {
        pageNo: this.currentPage,
        pageSize: Constant.pageSize
      };
      // this.fetchList(params);
    },
    batchItemShow(type) {
      return hasPermission(prescriptionHandlerRule[type].rule);
    },
    initData() {
      this.currentPage = 1;
      this.prescriptionRes = {};
      this.searchData = {
        id: '',
        drugstore: '',
        patientName: '',
        date: '',
        prescriptionTotalStatus: '',
        advisoryType: '',
        drugName: '',
        phoneNumber: '',
        printStatus: ''
      };
    },
    batchPrint() {
      if (this.prescriptionTemplate === 1) {
        if (this.printImg.length === 0) {
          this.$message.info('请选择需要打印的处方');
          return;
        }

        this.printsModeVisible = true;
      } else {
        Fetch.getImgUrlByPrescriptionIdList({ prescriptionIdList: this.printImg.map(v => v.id), colourType: 1 }).then(
          res => {
            if (res.urlInfoList && res.urlInfoList.length > 0) {
              const source = res.urlInfoList.map(v => ({ ...v, prescriptionImg: v.prescriptionImgUrl }));
              print(source, () => {
                this.toolBarStatus = 'init';
                this.handleCurrentChange();
                Fetch.print_prescription(this.printImg.map(v => v.id));
                this.printImg = [];
              });
              Telescope.trackEvent({
                trackId: 'zywzpc-click-PrescriptionList-JointPrint'
              });
            }
          }
        );
      }
    },
    async batchPrintConfirm(mode) {
      const { imgUrlList } = await Fetch.batchPrintImage({
        idList: this.printImg.map(v => v.id),
        printType: mode
      });

      print(
        imgUrlList,
        async () => {
          this.toolBarStatus = 'init';
          this.handleCurrentChange();
          await Fetch.print_prescription(this.printImg.map(v => v.id));
          this.printImg = [];
          this.printsModeVisible = false;
          Telescope.trackEvent({
            trackId: 'zywzpc-click-PrescriptionList-JointPrint'
          });
        },
        'pfd'
      );
    },
    search(data) {
      console.log(data);
      data && (this.searchData = { ...this.searchData, ...data });
      this.currentPage = 1;
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        newQuery: 1,
        ...this.searchData
      };
      if (params.date) {
        [params.startTime, params.endTime] = params.date;
      }
      let self = this;
      Util.submitOnce(function () {
        self.fetchList(params);
      });
    },
    handleCurrentChange(val) {
      if (val) {
        this.currentPage = val;
      }

      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.searchData,
        newQuery: 0
      };
      if (params.date) {
        [params.startTime, params.endTime] = params.date;
        params.endTime = formatEndTime(params.endTime);
        delete params.date;
      }
      this.fetchList(params);
    },
    fresh() {
      this.toolBarStatus = 'init';
      this.handleCurrentChange();
    },
    handleSizeChange(val) {
      let params = {
        pageNo: this.currentPage,
        pageSize: val || this.pageSize,
        ...this.searchData
      };
      if (params.date) {
        [params.startTime, params.endTime] = params.date;
        delete params.date;
      }
      console.log(params);
      this.fetchList(params);
    },
    fetchList(params) {
      if (!isloadFinish) return;
      isloadFinish = false;
      // 监管账号只显示已完成的处方
      this.$store.getters.superviseRole && (params.prescriptionTotalStatus = 2);
      params = delObjectEmpty(params);

      const fetchList = Fetch.prescriptionList(params).then(
        res => {
          this.prescriptionRes = res;
          isloadFinish = true;
        },
        () => {
          this.prescriptionRes = {};
          isloadFinish = true;
          this.$message.error('数据量过大，请缩小搜索范围');
        }
      );
      const fetchImageCount =
        params.prescriptionTotalStatus === '2' || !params.prescriptionTotalStatus
          ? Fetch.prescriptionList({
              prescriptionTotalStatus: '2',
              pageNo: 1,
              pageSize: 1,
              ...params
            }).then(res => {
              this.imageCount = res.totalCount;
            })
          : new Promise(resolve => {
              this.imageCount = 0;
            });

      Promise.all([fetchList, fetchImageCount]);
    },
    delPrescription(ids) {
      return this._prescription
        .delPrescription(ids)
        .then(res => {
          this.handleCurrentChange();
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleCommand(command) {
      this._prescription.batchIds = [];
      this.selectBatchType = command === '取消' ? null : command;
    },
    /* 1.9.7 批量下载文件走下载中心 */
    batchDelete() {
      this.toolBarStatus = 'delete';
      this.selectBatchType = this.batchTypes[1];
      Telescope.trackEvent({
        trackId: 'zywzpc-click-PrescriptionList-BulkDelete'
      });
    },
    batchDeleteConfirm() {
      if (!this.selectCount) {
        this.$message(`请先勾选需要删除的处方`);
      } else {
        this.delPrescription(this._prescription.batchIds.join()).then(_ => {
          this.selectBatchType = null;
          this.toolBarStatus = 'init';
        });
      }
    },
    batchDownload() {
      this.toolBarStatus = 'download';
      this.selectBatchType = this.batchTypes[0];
    },
    batchDownloadConfirm() {
      if (!this.selectCount) {
        this.$message(`请先勾选需要下载的处方`);
      } else {
        // todo 导出图片文件
        const limit = 3000;
        if (this.selectCount > limit) {
          this.$alert(`导出数据量过大会导致导出失败，建议调整导出范围，最大导出数量为${limit}张图片`, '数据导出失败', {
            customClass: 'hint',
            center: true,
            confirmButtonText: '重新选择导出范围'
          });
        } else {
          DownloadModal.show({
            selectCallback: context => {
              let [startTime, endTime] = this.searchData.date;
              Telescope.trackEvent({
                trackId: 'zywzpc-click-PrescriptionList-BulkDownload1'
              });
              this.$store.dispatch('download/exportFile', {
                exportType: 'export_prescription_img_async',
                idList: this._prescription.batchIds,
                ...context.downloadFrom,
                endTime,
                startTime,
                callback: () => {
                  this.toolBarStatus = 'init';
                  this.selectBatchType = null;
                  context.showDownload = false;
                  this._prescription.batchIds = [];
                }
              });
            }
          });
        }
      }
    },
    downloadAll() {
      // todo 导出图片文件
      if (!this.imageCount) {
        this.$message('没有图片可以导出');
      } else {
        // const limit = 3000;
        // if (this.imageCount > limit) {
        //   this.$alert(`导出数据量过大会导致导出失败，建议调整导出范围，最大导出数量为${limit}张图片`, '数据导出失败', {
        //     customClass: 'hint',
        //     center: true,
        //     confirmButtonText: '重新选择导出范围'
        //   });
        // } else {
        DownloadModal.show({
          selectCallback: context => {
            const { date, prescriptionTotalStatus, ...rest } = this.searchData;
            let [startTime, endTime] = this.searchData.date || [];
            Telescope.trackEvent({
              trackId: 'zywzpc-click-PrescriptionList-BulkDownload2'
            });
            const params = {
              ...delObjectEmpty({
                exportType: 'export_prescription_img_async',
                prescriptionTotalStatus: prescriptionTotalStatus || null,
                pageNo: 1,
                pageSize: this.imageCount,
                ...rest,
                startTime,
                endTime,
                ...context.downloadFrom
              })
            };
            this.$store.dispatch('download/exportFile', {
              ...params,
              callback: () => {
                this.toolBarStatus = 'init';
                context.showDownload = false;
                this._prescription.batchIds = [];
              },
              retryCallback: message => {
                MessageBox.confirm(message, '下载超量提醒', {
                  center: true,
                  confirmButtonText: '继续下载',
                  cancelButtonText: '调整下载量',
                  beforeClose: (action, instance, done) => {
                    const { companyName, companyId, isChain, ucUserId, roleListFromBk, mobile } =
                      this.$store.state.global;
                    switch (action) {
                      case 'confirm':
                        done();
                        Telescope.trackEvent({
                          trackId: 'zywzpc-click-PrescriptionList-exportPrescriptionImg',
                          custom: {
                            type: '继续下载',
                            companyId,
                            companyName,
                            userId: ucUserId,
                            mobile,
                            isChain,
                            roleList: roleListFromBk,
                            time: new Date().getTime()
                          }
                        });

                        this.$store.dispatch('download/exportFile', {
                          ...params,
                          confirmOverdownload: true,
                          callback: () => {
                            this.toolBarStatus = 'init';
                            context.showDownload = false;
                            this._prescription.batchIds = [];
                          }
                        });
                        break;
                      case 'cancel':
                      case 'close':
                        done();
                        Telescope.trackEvent({
                          trackId: 'zywzpc-click-PrescriptionList-exportPrescriptionImg',
                          custom: {
                            type: '调整下载量',
                            companyId,
                            companyName,
                            userId: ucUserId,
                            mobile,
                            isChain,
                            roleList: roleListFromBk,
                            time: new Date().getTime()
                          }
                        });
                        break;
                    }
                  }
                });
              }
            });
          }
        });
        // }
      }
    },
    exportAll() {
      // todo 导出处方
      if (!this.prescriptionRes.totalCount) {
        this.$message('没有处方可以导出');
      } else {
        if (this.prescriptionRes.totalCount > 49999) {
          this.$alert('导出数据量过大会导致导出失败，建议调整导出范围，最大导出数量为49999条', '数据导出失败', {
            confirmButtonText: '重新选择导出范围',
            customClass: 'hint',
            center: true
          });
        } else {
          const { date, prescriptionTotalStatus, ...rest } = this.searchData;

          const [startTime, endTime] = this.searchData.date || [];
          Telescope.trackEvent({
            trackId: 'zywzpc-click-PrescriptionList-export'
          });
          this.$store.dispatch(
            'download/exportFile',
            delObjectEmpty({
              exportType: 'export_prescription_async',
              ...rest,
              prescriptionTotalStatus: prescriptionTotalStatus || null,
              pageNo: 1,
              startTime,
              endTime,
              pageSize: this.prescriptionRes.totalCount
            })
          );
        }
      }
    },
    exportPrescriptionDetail() {
      // todo 导出处方详情
      if (!this.prescriptionRes.totalCount) {
        this.$message('没有处方可以导出');
      } else {
        if (this.prescriptionRes.totalCount > 49999) {
          this.$alert('导出数据量过大会导致导出失败，建议调整导出范围，最大导出数量为49999条', '数据导出失败', {
            confirmButtonText: '重新选择导出范围',
            customClass: 'hint',
            center: true
          });
        } else {
          const { date, prescriptionTotalStatus, ...rest } = this.searchData;

          const [startTime, endTime] = this.searchData.date || [];
          this.$store.dispatch(
            'download/exportFile',
            delObjectEmpty({
              exportType: 'export_prescription_detail_async',
              ...rest,
              prescriptionTotalStatus: prescriptionTotalStatus || null,
              pageNo: 1,
              startTime,
              endTime,
              pageSize: this.prescriptionRes.totalCount
            })
          );
        }
      }
    },
    initToolBarStatus() {
      this.toolBarStatus = 'init';
      this.selectBatchType = null;
    },
    queryDrugName(drugName, cb) {
      if (drugName.length > 1) {
        Fetch.get_company_drug_list(drugName).then(
          ({ data: drugList }) => {
            cb(drugList);
          },
          _ => {
            // eslint-disable-next-line standard/no-callback-literal
            cb([]);
          }
        );
      } else {
        // eslint-disable-next-line standard/no-callback-literal
        cb([]);
      }
    },
    handleDownloadBatchEMR() {
      this.toolBarStatus = 'downloadEMR';
      this.selectBatchType = this.batchTypes[0];
    },
    batchDownloadEMRConfirm() {
      if (!this.selectCount) {
        this.$message(`请先勾选需要下载的处方`);
      } else {
        // todo 导出图片文件
        const limit = 1500;
        if (this.selectCount > limit) {
          this.$alert(`导出数据量过大会导致导出失败，建议调整导出范围，最大导出数量为${limit}张图片`, '数据导出失败', {
            customClass: 'hint',
            center: true,
            confirmButtonText: '重新选择导出范围'
          });
        } else {
          let [startTime, endTime] = this.searchData.date;
          this.$store.dispatch('download/exportFile', {
            exportType: 'export_prescription_and_emr_img_async',
            idList: this._prescription.batchIds,
            endTime,
            startTime,
            colourType: 1,
            fileType: 0,
            callback: () => {
              this.toolBarStatus = 'init';
              this.selectBatchType = null;
              this._prescription.batchIds = [];
            }
          });
        }
      }
    },
    handleDownloadQueryedEMR() {
      if (!this.imageCount) {
        this.$message('没有图片可以导出');
      } else {
        // const limit = 1500;
        // if (this.imageCount > limit) {
        //   this.$alert(`导出数据量过大会导致导出失败，建议调整导出范围，最大导出数量为${limit}张图片`, '数据导出失败', {
        //     customClass: 'hint',
        //     center: true,
        //     confirmButtonText: '重新选择导出范围'
        //   });
        // } else {
        const { date, prescriptionTotalStatus, advisoryType, printStatus, prescriptionType, ...rest } = this.searchData;
        let [startTime, endTime] = this.searchData.date || [];
        const params = {
          ...delObjectEmpty({
            exportType: 'export_prescription_and_emr_img_async',
            prescriptionTotalStatus: prescriptionTotalStatus ? Number(prescriptionTotalStatus) : null,
            advisoryType: advisoryType ? Number(advisoryType) : null,
            printStatus: printStatus ? Number(printStatus) : null,
            prescriptionType: prescriptionType ? Number(prescriptionType) : null,
            pageNo: 1,
            pageSize: this.imageCount,
            ...rest,
            startTime,
            endTime,
            fileType: 0,
            colourType: 1
          })
        };
        this.$store.dispatch('download/exportFile', {
          ...params,
          callback: () => {
            this.toolBarStatus = 'init';
            this._prescription.batchIds = [];
          },
          retryCallback: message => {
            MessageBox.confirm(message, '下载超量提醒', {
              center: true,
              confirmButtonText: '继续下载',
              cancelButtonText: '调整下载量',
              beforeClose: (action, instance, done) => {
                const { companyName, companyId, isChain, ucUserId, roleListFromBk, mobile } = this.$store.state.global;
                switch (action) {
                  case 'confirm':
                    done();
                    Telescope.trackEvent({
                      trackId: 'zywzpc-click-PrescriptionList-exportPrescriptionAndEmr',
                      custom: {
                        type: '继续下载',
                        companyId,
                        companyName,
                        userId: ucUserId,
                        mobile,
                        isChain,
                        roleList: roleListFromBk,
                        time: new Date().getTime()
                      }
                    });
                    this.$store.dispatch('download/exportFile', {
                      ...params,
                      confirmOverdownload: true,
                      callback: () => {
                        this.toolBarStatus = 'init';
                        this._prescription.batchIds = [];
                      }
                    });
                    break;
                  case 'cancel':
                  case 'close':
                    done();
                    Telescope.trackEvent({
                      trackId: 'zywzpc-click-PrescriptionList-exportPrescriptionAndEmr',
                      custom: {
                        type: '调整下载量',
                        companyId,
                        companyName,
                        userId: ucUserId,
                        mobile,
                        isChain,
                        roleList: roleListFromBk,
                        time: new Date().getTime()
                      }
                    });
                    break;
                }
              }
            });
          }
        });
        // }
      }
    }
  }
};
</script>

<style lang="scss">
.tab-pre,
.el-breadcrumb {
  font-size: 12px;
  color: #999999;
  line-height: 40px;
}

.el-table th {
  background: #f7f7f7;
  color: #666;
}

.el-pagination__total,
.el-pagination__jump {
  color: #999;
}
</style>

<style lang="scss" scoped>
// 解决打印样式问题，譬如阴影残留
@media print {
  .list-content {
    background: #ffffff !important;
    border: none !important;
    box-shadow: 0 0px 0px 0 #ffffff !important;
    border-radius: 0px !important;
    padding: 0px !important;
    max-height: auto !important;
  }
}

.title-area {
  overflow: hidden;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .main-title {
    line-height: 46px;
  }

  .main-right {
    display: flex;
    align-items: center;
  }

  .btn {
    height: 46px;
    padding: 0 18px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 3px;
    color: #707070;
    font-size: 12px;
    cursor: pointer;
    margin-left: 16px;

    .batch-handler {
      display: inline-block;
      padding: 5px 0;
      font-size: 12px;
    }
  }
}

.totalData {
  color: #333;
  font-size: 14px;
  line-height: 30px;
}

.list-content {
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0 4px 12px 0 #ededed;
  border-radius: 4px;
  padding: 16px;
  max-height: 100%;

  .listSearchArea {
    padding-bottom: 20px;

    &:after {
      content: '.';
      display: block;
      height: 0;
      clear: both;
      visibility: hidden;
    }

    .select_from_store_name {
      float: left;
    }
  }
}

.footer {
  overflow: hidden;
  display: flex;
  justify-content: center;
  margin-top: 16px;
  .sureJump {
    width: 80px;
    height: 32px;
    border-radius: 3px;
    text-align: center;
    line-height: 32px;
    cursor: pointer;
    margin-top: 20px;
    margin-left: 10px;
  }
}

.search-btn {
  background: #1e8dff !important;
  color: #1e8dff !important;
  background: #ffffff !important;
  border: 1px solid #1e8dff !important;
  margin-left: 10px;

  &:hover {
    background: rgba(68, 184, 91, 0.1) !important;
  }
}

.toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 15px;
  min-height: 45px;

  .delete {
    &:hover {
      color: #e0514c !important;
      border-color: #e0514c !important;
    }

    &:focus {
      color: #e0514c !important;
      border-color: #e0514c !important;
    }
  }
}

.toolbar-in-enter-active,
.toolbar-in-leave-active {
  transition: all 0.3s;
}

.toolbar-in-enter,
.toolbar-in-leave-to {
  transform: translateY(30%);
  opacity: 0;
}
</style>
